import { fetchSystemCSV } from '@api/system';
import { useSelector } from 'react-redux';
import { useAlert } from '@hooks/useAlert';
import { OrangeButton } from './OrangeButton';
import type { RootState } from '@features/redux/store';

export const ExportSystems = ({ params }: { params: Record<string, string> }) => {
    const { IdToken } = useSelector((state: RootState) => state.auth);

    const { setAlert } = useAlert();

    const downloadCSV = async () => {
        const data = await fetchSystemCSV(IdToken!, params).catch((err) => setAlert(err.message, 'error'));

        const csvData = `data:text/csv;base64,${btoa(unescape(encodeURIComponent(data)))}`;

        const link = document.createElement('a');
        link.setAttribute('href', csvData);
        link.setAttribute('download', `${params.type}-systems.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <OrangeButton style={{ margin: '0px' }} onClick={() => downloadCSV()}>
            Export
        </OrangeButton>
    );
};
